import React from 'react';
import { Helmet } from 'react-helmet-async';

const ImageOptimization = () => {
  return (
    <Helmet>
      {/* Image optimization meta tags */}
      <meta name="image-optimization" content="webp,avif,progressive-jpeg" />
      
      {/* Add service worker for image caching and optimization */}
      <script>
        {`
          // Register service worker for image optimization
          if ('serviceWorker' in navigator) {
            window.addEventListener('load', function() {
              navigator.serviceWorker.register('/sw.js')
                .then(function(registration) {
                  console.log('SW registered: ', registration);
                })
                .catch(function(registrationError) {
                  console.log('SW registration failed: ', registrationError);
                });
            });
          }
          
          // Lazy loading with intersection observer
          document.addEventListener('DOMContentLoaded', function() {
            const imageObserver = new IntersectionObserver((entries, observer) => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  const img = entry.target;
                  
                  // Check for modern format support
                  const supportsWebP = (function() {
                    const canvas = document.createElement('canvas');
                    return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
                  })();
                  
                  const supportsAVIF = (function() {
                    const canvas = document.createElement('canvas');
                    return canvas.toDataURL('image/avif').indexOf('data:image/avif') === 0;
                  })();
                  
                  // Update image source based on format support
                  if (img.dataset.src) {
                    let src = img.dataset.src;
                    
                    if (supportsAVIF && img.dataset.avif) {
                      src = img.dataset.avif;
                    } else if (supportsWebP && img.dataset.webp) {
                      src = img.dataset.webp;
                    }
                    
                    img.src = src;
                    img.classList.remove('lazy');
                    img.classList.add('loaded');
                  }
                  
                  observer.unobserve(img);
                }
              });
            });
            
            // Observe all images with data-src attribute
            document.querySelectorAll('img[data-src]').forEach(img => {
              imageObserver.observe(img);
            });
          });
        `}
      </script>
      
      <style>
        {`
          /* Lazy loading styles */
          img.lazy {
            opacity: 0;
            transition: opacity 0.3s;
          }
          
          img.loaded {
            opacity: 1;
          }
          
          /* Picture element optimization */
          picture {
            display: block;
          }
          
          /* Responsive image optimization */
          img {
            max-width: 100%;
            height: auto;
          }
        `}
      </style>
    </Helmet>
  );
};

export default ImageOptimization;